import { useMemo } from 'react';
import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const useInventoryValidator = (requireDealer = true) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredString('moduleId'),
                validators.only(() => requireDealer, validators.requiredString('dealerId')),

                // even though it just shadow, validate it
                validators.requiredString('modelId')
            ),
        [requireDealer]
    );

    return useValidator(validator);
};

export default useInventoryValidator;
